import { Component, Input, OnInit } from '@angular/core';
import { RenaultUserAnimationDataDTO } from '../../../models/renault-user-dto';
import { RenaultUserMyServiceDataDTO } from 'src/app/models/renault-myservice-dto';

@Component({
  selector: 'myservice-action-user-card',
  templateUrl: './myservice-action-user-card.component.html',
  styleUrls: ['./myservice-action-user-card.component.scss']
})
export class MyServiceActionUserCardComponent implements OnInit {

  @Input() model: RenaultUserMyServiceDataDTO;
  

  constructor() { }

  ngOnInit(): void {
  
  }

  


}
